import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { RTL_LANGUAGES } from './Constants/language';
import { basename } from "./Constants/env";

const setDocumentDirection = (language) => {
  const dir = RTL_LANGUAGES.includes(language) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = language;

  if (dir === 'rtl') {
    document.body.classList.add('rtl');
  } else {
    document.body.classList.remove('rtl');
  }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'es', 'de', 'zh', 'ar'],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'cookie', 'sessionStorage', 'querystring', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
    },
    backend: {
      // On native, use relative paths to locales. On web, keep basename + path.
      loadPath: (basename ? (basename + '/') : '') + 'locales/{{lng}}/{{ns}}.json',
    },
    saveMissing: false,
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      // Missing translation handler - could be used for logging in development
    },
  });

// Set initial direction based on detected language
setDocumentDirection(i18n.language);

// Keep document direction in sync with language
i18n.on('languageChanged', (lng) => {
  setDocumentDirection(lng);
});

export default i18n;
